var render = function render(_c, _vm) {
  return _c("notifications", {
    staticClass: "notifications",
    attrs: { group: "main", position: "top right" },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function(props) {
          return [
            _c(
              "div",
              {
                staticClass: "notification-content",
                class: props.item.data.icon
              },
              [
                _c(
                  "div",
                  { staticClass: "notification-icon" },
                  [
                    _c("svgicon", {
                      attrs: {
                        name: props.item.data.icon,
                        width: "24",
                        height: "24"
                      }
                    })
                  ],
                  1
                ),
                _c("div", [
                  props.item.data.title
                    ? _c(
                        "div",
                        { staticClass: "notification-title mg mg--b-1" },
                        [_vm._v(_vm._s(props.item.data.title))]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "notification-text" }, [
                    _vm._v(_vm._s(props.item.data.text))
                  ])
                ])
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }